module.exports = __webpack_public_path__ + "img/g29.4be47748.png";